import * as React from 'react';
import Text from '../../Base/Text/Text';
import FormTitle from '../FormTitle';
import Label from '../../Base/Label/Label';
import SideFilterLabel from '../../Filter/SideFilterLabel';

interface MagicFieldTextProps {
	itemScheme: any;
}

const MagicFieldText: React.FC<MagicFieldTextProps> = props => {
	const { itemScheme } = props;

	const label = itemScheme?.label || itemScheme?.title;

	switch (itemScheme?.subType) {
		case 'header':
			return <FormTitle tx={label} type={'default'} />;
		case 'subtitle':
			return <FormTitle tx={label} type={'subtitle'} />;
		case 'category':
			return <FormTitle tx={label} type={'category'} />;
		case 'label':
			return <Label tx={label} isOptional={itemScheme?.settings?.isOptional} />;
		case 'filterLabel':
			return <SideFilterLabel tx={label} />;
		default:
			return <Text>{itemScheme.title}</Text>;
	}
};

export default MagicFieldText;
